export class SmsMessage {
    orderId!: string;
    phoneNumber!: string;
    textMessage!: string;
}

export enum MessageType {
    CourierWaiting,
    ArrivingSoon = 'ArrivingSoon',
    Delayed = 'Delayed'
}